import { Component, Input, OnInit } from '@angular/core';
import { PropertyListing } from '@app-services/listing';

@Component({
	selector: 'app-public-header',
	templateUrl: './public-header.component.html',
	styleUrls: ['./public-header.component.scss']
})
export class PublicHeaderComponent implements OnInit {
	@Input() data: PropertyListing['cardholder'];
	@Input() isPreview: boolean;

	constructor() {}

	ngOnInit(): void {}
}
